import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import OfferOptionButton from '../../../../../../components/offers/offer-options/OfferOptionButton';
import ComparisonMatrixOverviewBox from './ComparisonMatrixOverviewBox';
import IconText from '../../shared/IconText';

// Types
import { LouiseQuote } from '../../../../../../../../../types/Quotes';
import { Box, Icon, IconName, Text } from '@wegroup/design-system';

interface Props {
  quote: LouiseQuote;
}

const ComparisonMatrixOverview = forwardRef<HTMLDivElement, Props>(
  ({ quote }, ref) => {
    const { t } = useTranslation();

    const importantQualities = quote.quality?.flatMap((option) =>
      option.coverage_groups.filter(
        ({ is_important_to_customer }) => !!is_important_to_customer,
      ),
    );

    return (
      <Box ref={ref} borderRadius="md" bg="gray.ultraLight" p="4" m="4">
        <Text mb="4" textStyle="largeBodyBold">
          {t('Overview')}
        </Text>
        {!!importantQualities?.length && (
          <ComparisonMatrixOverviewBox title={t('Important for you')}>
            {importantQualities.map(
              ({ is_important_to_customer, icon_key, name }, index) =>
                is_important_to_customer && (
                  <IconText
                    key={index}
                    Icon={
                      <Icon name={icon_key as IconName} color="primary.500" />
                    }
                  >
                    {name}
                  </IconText>
                ),
            )}
          </ComparisonMatrixOverviewBox>
        )}
        <ComparisonMatrixOverviewBox title={t('Options')} wrapItems>
          {quote.guarantee_content?.map(({ key, description, name }) => (
            <OfferOptionButton
              key={key}
              type={key}
              active={quote.selected_guarantees.includes(key)}
              disabled
              isSmall
              insuranceType={quote.info.insurance_type}
              description={description}
            >
              {name}
            </OfferOptionButton>
          ))}
        </ComparisonMatrixOverviewBox>
      </Box>
    );
  },
);

export default ComparisonMatrixOverview;
